export enum RosterEnums {
    TRIALS = 'TRIALS',
    RENEWALS = 'RENEWALS',
    PRREQUESTS = 'PR_REQUESTS',
    ONEMEALSERVICE = "ONE_MEAL_SERVICE",
    COOK_PROFILE_LEADS = 'COOK_PROFILE_LEADS'
}
